<!-- 设置mfa -->
<template>
    <div>
        <div class="mask"></div>
        <div class="edit_box" v-loading="loading">
            <div class="box_head">
                <p>{{ $t('common.open') }}MFA</p>
                <i @click="closePopup(false)"></i>
            </div>
            <div class="box_body">

                <template v-if="step===1">
                    <div class="title">{{ isZh?'指定MFA设备名称':'Specify MFA device name' }}</div>
                    <div class="line">
                        <span class="lab"><i class="mark_icon">*</i>{{ $t('common.device') + $t('common.name') }}：</span>
                        <div :class="{'error_border':tipNum===1}">
                            <el-input type="text" :placeholder="$t('common.input')+$t('common.device')+$t('common.name')"
                                      v-model.trim="deviceName"
                                      @input="tipNum=-1" maxlength="255" :disabled="step===2"></el-input>
                        </div>
                    </div>
                    <div class="line">
                        <span class="lab"></span>
                        <div class="tip">{{ isZh?'输入一个有意义的名称来标识此设备':'Enter a meaningful name to identify this device' }}</div>
                    </div>
                </template>


                <template v-if="step!==1">
                    <div class="title">{{ isZh?'设置您的身份验证器应用程序':'Set up your authenticator application' }}</div>
                    <div class="title" style="font-weight: 400;">{{ isZh?'虚拟MFA设备是在您的设备上运行的应用程序，您可以扫描QR代码对其进行配置':'Virtual MFA devices are applications that run on your device, and you can scan QR codes to configure them' }}</div>
                    <div class="line">
                        <span class="lab"></span>
                        <div>
                            <img class="code" :src="code" alt="">
                        </div>
                    </div>
                    <div class="title">
                        <span>{{ isZh?'加打开谷歌':'Open Google' }}</span>
                        <img class="icon_logo" src="../../assets/img/Google.png" alt="Google" title="Google"/>
                        <span>{{ isZh?'或者微软':' or Microsoft' }}</span>
                        <img class="icon_logo" src="../../assets/img/Microsoft.png" alt="Microsoft" title="Microsoft"/>
                        <span>{{ isZh?'身份验证器，选择此页面上的显示 QR 代码，然后使用该应用程序扫描该代码':' Authenticator, select the QR code displayed on this page, and then use the application to scan the code' }}。</span>
                    </div>

                    <div class="line">
                        <span class="lab"><i class="mark_icon">*</i>MFA{{ isZh?'代码':' code' }}：</span>
                        <div class="flex" :class="{'error_border':tipNum===2}">
                            <el-input type="text" :placeholder="$t('common.input')+ 'MFA'+(isZh?'代码':' code')" v-model.trim="mfaCode"
                                      @input="tipNum=-1" maxlength="6" :disabled="step!==2"></el-input>
                        </div>
                    </div>
                    <div class="line" v-if="step===3">
                        <span class="lab"><i class="mark_icon">*</i>{{isZh?'确认':'Confirm'}}MFA{{ isZh?'代码':' code' }}：</span>
                        <div class="flex" :class="{'error_border':tipNum===3}">
                            <el-input type="text" :placeholder="$t('common.input')+(isZh ? '第二个MFA代码' : 'the second MFA code') " v-model.trim="regCode" @input="tipNum=-1" maxlength="6"></el-input>
                        </div>
                    </div>
                </template>
                <p class="error_line">{{ infoTip }}</p>
            </div>
            <div class="box_foot">
                <span @click="closePopup(false)">{{ $t('btn.cancel') }}</span>
                <span v-if="step===1" @click="confirmEdit">{{ isZh ? '下一步' : 'Next step' }}</span>
                <span v-if="step===2" @click="checkMFA">{{ $t('btn.check') }}</span>
                <span v-if="step===3" @click="recalibrationMFA">{{ $t('btn.check') }}</span>
            </div>
        </div>
    </div>
</template>

<script>

import {mixins} from "../../utils/mixins";
import {bindCustomerCode, bindCustomerName, regCustomerCode} from "../../api/base/staff";

export default {
    mixins: [mixins],
    props: {
        // 开启的用户code
        userId: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            tipNum: '',
            deviceName: '',
            mfaCode: '',
            regCode: '',
            random: '',
            code: '', // 二维码
            step: 1,
            loading: false
        }
    },
    computed: {
        infoTip() {
            if (this.tipNum === 1) {
                return this.$t('common.input') + this.$t('common.device') + this.$t('common.name')
            } else if (this.tipNum === 2) {
                return this.$t('common.input') + 'MFA'+(this.isZh?'代码':' code')
            } else if (this.tipNum === 3) {
                return this.$t('common.input') + (this.isZh ? '第二个MFA代码' : 'the second MFA code')
            }
            return ''
        }
    },
    mounted() {

    },
    methods: {
        // 确认修改
        confirmEdit() {
            if (this.deviceName === '') {
                this.tipNum = 1;
            } else {
                this.sendDeviceName();
            }
        },

        // 提交设备名
        sendDeviceName() {
            let that = this;
            that.loading = true;
            let data = {
                deviceName: that.deviceName,
                uniqueCode: that.userId,
            }
            bindCustomerName(JSON.stringify(data)).then(response => {
                try {
                    let enc = new TextDecoder('utf-8')
                    response = JSON.parse(enc.decode(new Uint8Array(response)))
                    if (response && (!response.hasOwnProperty('success') || response.success)) {
                        that.step = 2
                        that.code = response.data.base
                        that.random = response.data.random

                    } else {
                        let msg = response ? (this.isZh ? response.message : response.emsg) : (this.isZh ? '操作失败' : 'Operation failed');
                        this.$message.error({
                            message: msg,
                            showClose: true
                        })
                    }
                } catch (error) {
                    console.error(error);
                }
                that.loading = false;
            }).catch((e) => {
                that.loading = false;
            });
        },
        // 校验
        checkMFA() {
            let that = this;
            if (this.mfaCode === '') {
                return this.tipNum = 2;
            }
            that.loading = true;
            let data = {
                code: that.mfaCode,
                uniqueCode: that.userId,
                random: that.random,
            }
            bindCustomerCode(JSON.stringify(data)).then(response => {
                if (response.success) {
                    that.step = 3
                }
                that.loading = false;
            }).catch((e) => {
                that.loading = false;
            });
        },
        // 再次校验
        recalibrationMFA() {
            let that = this;
            if (this.regCode === '') {
                return this.tipNum = 3;
            }
            that.loading = true;
            let data = {
                code: that.regCode,
                uniqueCode: that.userId,
            }
            regCustomerCode(JSON.stringify(data)).then(async response => {
                if (response.success) {
                    try {
                        await that.$store.dispatch('updateHasMfaAsync');
                        that.$message.success({
                            message: that.$t('btn.success'),
                            duration: 1000,
                            showClose: true
                        });
                    } catch (e) {
                        console.error(e)
                    }
                    that.closePopup(true)
                }
                that.loading = false;
            }).catch((e) => {
                that.loading = false;
            });
        }
    }
}
</script>

<style scoped>
.edit_box{
    width: 660px;
    margin-left: -330px;
    top: 5%;
}
.line .lab {
    width: 140px;
}

.code {
    width: 200px;
    height: 200px;
}

.flex {
    display: flex;
    gap: 10px;
}
.title{
    width: 410px;
    font-weight: 600;
    padding-left: 150px;
    padding-bottom: 10px;
    /*display: flex;*/
    /*justify-content: flex-start;*/
    /*align-items: baseline;*/
}
.title  span {
    /*display: inline-block; !*将文字显示为行内块级元素*!*/
    vertical-align: middle; /*让文字垂直居中*/
}
.tip{
    color: #ff2c2c;
}
.icon_logo{
    display: inline-block; /*将图片显示为行内块级元素*/
    vertical-align: middle; /*让图片垂直居中*/
    width: 33px;
    height: 28px;
    /*float: left;*/
}
/deep/ .el-input.is-disabled .el-input__inner{
    background-color: #e1f3d8 !important;
    color: #67C23A !important;
}
</style>



// WEBPACK FOOTER //
// src/components/setMFA/index.vue